import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Button,
  Image,
  Platform,
  Modal,
  ActivityIndicator,
  PixelRatio,
  Dimensions,
} from "react-native";
import React, { useContext, useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import { useNavigation } from "@react-navigation/native";
import BackArrow from "../../icons/BackArrow";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import TransactionCodeSetUpScreen from "../transactionDigitCode/TransactionCodeSetUpScreen";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import useAuth from "../../hooks/useAuth";
import AppContext from "../../context/AppContext";
import Icon from "react-native-vector-icons/Ionicons";
import { SafeAreaView } from "react-native-safe-area-context";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const UsernamePasswordTransactCode = ({
  hideModal,
  forTransactionCodeSetup,
  setPasswordIsCorrect,
  setShowEmailEntry,
}) => {
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);

  const [isUsernameValid, setIsUsernameValid] = useState(true);
  const [successMessasge, setSuccessMessage] = useState("");
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [isVerifyEmailCodeVisible, setIsVerifyEmailCodeVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [showTransactionCodeScreen, setShowTransactionCodeScreen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { username } = useAuth();
  const { logOut } = useContext(AppContext);

  //const [email, setEmail] = useState('')
  const [password, setPassword] = useState("");
  const [validEmail, setValidEmail] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [buttonActive, setButtonActive] = useState(false);

  // const navigate = useNavigation()

  const axiosPrivate = useAxiosPrivate();

  // const handleEmailEntry = (text) => {
  //     //console.log('email', text)
  //     setEmail(text)
  //     setValidEmail(validateEmail(text))
  // }

  const handlePasswordEntry = (text) => {
    //console.log('password', text)
    setPassword(text);
  };

  // const validateEmail = (email) => {
  //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  //     return emailRegex.test(email)
  // }

  // const validateEmailForms = () => {
  //     if (!username) {
  //         setIsEmailFocused(true)
  //     } else if (validEmail === false) {
  //         setErrorMessage('Enter a valid email address')
  //         setIsErrorCompVisible(true)
  //     } else if (password === '') {
  //         setIsPasswordFocused(true)
  //     } else {
  //         submitEmailPassword_to_db()
  //     }
  // }

  const validateForms = () => {
    if (!username) {
      return;
    } else if (password === "") {
      setIsPasswordFocused(true);
    } else {
      submitEmailPassword_to_db();
    }
  };

  const showOneOfThese = async () => {
    if (forTransactionCodeSetup) {
      setShowTransactionCodeScreen(true);
    } else {
      setPasswordIsCorrect(true);
      hideModal();
    }
  };

  const submitEmailPassword_to_db = async () => {
    setIsLoading(true);

    try {
      // const res = await axiosPrivate.post('/reVerifyUser/reVerifyUser', { email, password });
      const res = await axiosPrivate.post("/reVerifyUser/reVerifyUser", { username, password });
      //console.log('response', res.data.message);

      if (res.status === 200 || res.status === 201) {
        //console.log(res.data.message)
        showOneOfThese();
      } else {
        setErrorMessage("Email verification failed");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      if (error.response) {
        const { type, message } = error.response.data;

        if (type === "LOCKED") {
          // Backend says account is locked
          logOut();
          setErrorMessage(message);
          setIsErrorCompVisible(true);
          setIsLocked(true);
          return;
        }

        if (type === "INVALID_PASSWORD") {
          // Wrong password but not locked
          setErrorMessage(message);
          setIsErrorCompVisible(true);
          return;
        }

        // Any other backend error (e.g. unauthorized, missing fields, etc.)
        setErrorMessage(message || "Login failed.");
        setIsErrorCompVisible(true);
      } else {
        // Network or unexpected error
        setErrorMessage("Login error!! Please try again.");
        setIsErrorCompVisible(true);
      }

      //console.log('LogIn Error', error);
    } finally {
      setIsLoading(false);
    }
  };

  // if (isLoading) {
  //     return (
  //         <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
  //             <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
  //         </View>
  //     )
  // }

  return (
    <View style={styles.createPullFormContainer}>
      <TouchableOpacity onPress={hideModal} style={styles.backButtonStyle}>
        <BackArrow color={Colours.DARKGRAY} />
      </TouchableOpacity>
      <View style={styles.profilePhotoContainer}>
        <Text
          style={{
            color: Colours.PRIMARY,
            fontSize: dynamicFontSize(20),
            fontFamily: "Sen-Regular",
          }}
        >
          Re-Verify
        </Text>
      </View>
      <View style={styles.textAndTxtInput}>
        <Text
          style={{
            color: Colours.DARKGRAY,
            fontSize: dynamicFontSize(15),
            fontFamily: "Sen-Regular",
          }}
        >
          USERNAME
        </Text>
        <AppTextInput
          style={[styles.textInputStyle, isEmailFocused && styles.focusedBorder]}
          value={username} // prefill
          editable={false} // disable editing
          fontSize={15}
          // keyboardType="email-address"
        />
      </View>
      {/* <View style={styles.textAndTxtInput}>
                <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>
                    EMAIL
                </Text>
                <AppTextInput style={[styles.textInputStyle, isEmailFocused && styles.focusedBorder,]}
                    placeholder='Enter email'
                    fontSize={15}
                    keyboardType='email-address'
                    onFocus={() => setIsEmailFocused(true)}
                    onBlur={() => setIsEmailFocused(false)}
                    onChangeText={handleEmailEntry}

                />

            </View> */}
      <View style={styles.textAndTxtInput}>
        <Text
          style={{
            color: Colours.DARKGRAY,
            fontSize: dynamicFontSize(15),
            fontFamily: "Sen-Regular",
          }}
        >
          PASSWORD
        </Text>
        <AppTextInput
          style={[styles.textInputStyle, isPasswordFocused && styles.focusedBorder]}
          placeholder="Enter password"
          fontSize={15}
          secureTextEntry={!showPassword}
          onFocus={() => setIsPasswordFocused(true)}
          onBlur={() => setIsPasswordFocused(false)}
          onChangeText={handlePasswordEntry}
        />
        <TouchableOpacity onPress={() => setShowPassword(!showPassword)}>
          <Icon
            name={showPassword ? "eye-off-outline" : "eye-outline"}
            size={dynamicSize(22)}
            color={Colours.PRIMARY_LIGHT}
            style={{ marginLeft: dynamicSpacing(10), marginTop: dynamicSize(10) }}
          />
        </TouchableOpacity>
      </View>
      <TouchableOpacity
        style={[
          styles.buttonGray,
          { backgroundColor: buttonActive ? Colours.DARKGRAY : Colours.PRIMARY },
        ]}
        onPress={() => {
          setButtonActive(true);
          validateForms();
        }}
        disabled={isLoading}
      >
        {isLoading ? (
          <ActivityIndicator size="small" color="white" />
        ) : (
          <Text style={{ color: "white", fontSize: dynamicFontSize(15), fontFamily: "Sen-Bold" }}>
            Proceed
          </Text>
        )}
      </TouchableOpacity>

      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      <Modal
        visible={showTransactionCodeScreen}
        // transparent={true}
        animationType="fade"
        onRequestClose={() => setShowTransactionCodeScreen(false)}
      >
        <TopHeaderComponent
          headerText={"Setup Transaction Code"}
          hideScreen={() => setShowTransactionCodeScreen(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <TransactionCodeSetUpScreen
            fromSettings={true}
            hideScreen={() => {
              setShowTransactionCodeScreen(false);
              hideModal();
            }}
            // setShowEmailEntry={setShowEmailEntry}
            // setIsVerifyEmailCodeVisible={setIsVerifyEmailCodeVisible}
          />
        </ScrollView>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  createPullFormContainer: {
    flex: 1, // Use flex: 1 to fill the screen
    paddingTop: dynamicSpacing(20),
    padding: dynamicSpacing(15),
    backgroundColor: "white",
  },
  backButtonStyle: {
    marginBottom: dynamicSize(60),
    marginTop: dynamicSize(60),
  },
  textAndTxtInputRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: dynamicSpacing(15),
  },
  textAndTxtInput: {
    marginTop: dynamicSpacing(15),
  },
  textInputStyle: {
    height: dynamicSpacing(50),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(15),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
  buttonGray: {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(15),
    marginTop: dynamicSpacing(25),
    height: dynamicSpacing(60),
  },
  profilePhotoContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginBottom: dynamicSpacing(10),
  },
  userImage: {
    width: dynamicSize(100),
    height: dynamicSize(100),
    borderRadius: dynamicSize(99),
    marginBottom: dynamicSpacing(3),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.PRIMARY,
    marginTop: dynamicSpacing(10),
    backgroundColor: Colours.LIGHTGRAY,
  },
});

export default UsernamePasswordTransactCode;
